import { EventEmitterInterface } from 'pf-frontend-common/src/module/event/emitter.interface';

import { DataStore } from 'common/module/data/store';
import { MortgageCampaignSaroutycreditsimulatorTemplatePropsInterface } from 'common/module/mortgage/campaign/saroutycreditsimulator/template-props.interface';
import { StatsServiceInterface } from 'common/service/stats/service.interface';

export class MortgageCampaignSaroutycreditsimulatorViewStore extends DataStore {
  /**
   * CTA tracked state
   */
  protected isCTATracked: boolean = false;

  /**
   * @inheritDoc
   */
  protected state: MortgageCampaignSaroutycreditsimulatorTemplatePropsInterface;

  /**
   * Constructor
   */
  constructor(eventEmitter: EventEmitterInterface, private statsService: StatsServiceInterface) {
    super(eventEmitter);
  }

  /**
   * @inheritDoc
   */
  public initialize(): void {
    this.state = {
      buttonUrl: 'http://simulateur.pf.ma/',
      onClick: this.onClick,
    };
  }

  /**
   * Onclick calculate button, track event
   */
  private onClick = () => {
    if (this.isCTATracked) {
      return;
    }

    this.statsService.ctaClick({
      cta: {
        calculator: {
          name: 'sarouty-simulateur-calculator-widget',
        },
      },
    });
    this.isCTATracked = true;
  };
}
